<div appDropIndicator [indicatorActive]="demand ? !demandReadOnly : false">
    <base-site-layout
        [heading]="demandReadOnly && demand?.title ? demand.title : (heading | translate)"
        headerIcon="fas fa-envelope-open-text"
        [loading]="!demand || !articles"
        [errorCode]="error()"
        [message403]="'Sie haben keine Berechtigung für diese Bedarfsmeldung.' | translate"
        [message404]="'Die Bedarfsmeldung wurde nicht gefunden.' | translate"
        [actions]="actions"
    >
        <ng-template #actions>
            <div class="btn-group btn-group-sm mb-1 mobile-button">
                @if (!demand.isAnnounced) {
                    <button class="btn btn-danger" (click)="clearUnannounced()" data-cy="CLEAR_DEMAND">
                        <em class="fas fa-trash pe-2"></em>
                        {{ 'verwerfen' | translate }}
                    </button>
                }
                @if (!task && isPending && currentUserIsConsumer() && !demandReadOnly) {
                    <button class="btn btn-warning" (click)="withdraw()" [disabled]="isCompleted">
                        <em class="fas fa-delete-left pe-1"></em>
                        {{ 'zurückziehen' | translate }}
                    </button>
                }
                <!--            TODO remove check for currentUserIsConsumer() when EPROC-8161 is implemented-->
                @if (!task && isPurchaseRequisition && currentUserIsConsumer()) {
                    <button class="btn btn-primary" (click)="createNewDemand()" [disabled]="isCompleted">
                        <em class="fas fa-plus pe-1"></em>
                        {{ 'In neuen Bedarf wandeln' | translate }}
                    </button>
                }
                @if (pdfPreviewStore.hasPdfFiles()) {
                    <button
                        type="button"
                        class="btn btn-primary"
                        (click)="pdfPreviewStore.togglePreview()"
                        data-cy="TOGGLE_PDF_PREVIEW"
                    >
                        @if (pdfPreviewStore.displayPreview()) {
                            <em class="fas fa-eye-slash pe-1"></em>
                            {{ 'Vorschau ausblenden' | translate }}
                        } @else {
                            <em class="fas fa-eye pe-1"></em>
                            {{ 'Vorschau' | translate }}
                        }
                    </button>
                }
            </div>
        </ng-template>
        @if (demand) {
            @if (isPurchaseRequisition) {
                <document-layout [isLoading]="documentLayoutLoading()">
                <document-sidemenu-section>
                    <document-sidemenu-section-header
                        [sectionTitle]="'Verknüpfte Dokumente' | translate"
                        icon="fas fa-diagram-project"
                    ></document-sidemenu-section-header>
                    <document-sidemenu-section-empty-message>
                        {{ 'Keine verknüpften Dokumente' | translate }}
                    </document-sidemenu-section-empty-message>
                    <ng-template #processChainCard let-linkedDocument>
                        <process-chain-related-document
                            [document]="linkedDocument"
                            [navigationAvailable]="!!linkedDocument.targetRoute"
                        ></process-chain-related-document>
                    </ng-template>
                    @for (
                        linkedDocument of linkedProcessDocuments();
                        track linkedDocument.documentType + '|' + linkedDocument.documentId
                    ) {
                        @if (linkedDocument.targetRoute) {
                            <document-sidemenu-card (cardClick)="navigateToLinkedDocument(linkedDocument)">
                                <ng-container
                                    *ngTemplateOutlet="processChainCard; context: { $implicit: linkedDocument }"
                                ></ng-container>
                            </document-sidemenu-card>
                        } @else {
                            <document-sidemenu-card>
                                <ng-container
                                    *ngTemplateOutlet="processChainCard; context: { $implicit: linkedDocument }"
                                ></ng-container>
                            </document-sidemenu-card>
                        }
                    }
                </document-sidemenu-section>
                <document-sidemenu-section>
                    <document-sidemenu-section-header
                        [sectionTitle]="'Anhänge' | translate"
                        icon="fas fa-paperclip"
                    ></document-sidemenu-section-header>
                    <document-sidemenu-section-empty-message>
                        {{ 'Keine Anhänge vorhanden' | translate }}
                    </document-sidemenu-section-empty-message>
                    @if (!demandReadOnly) {
                        <document-sidemenu-section-action
                            (actionClick)="upload(null, false)"
                        ></document-sidemenu-section-action>
                    }
                    @for (file of demand.publicFiles; track file.id) {
                        <document-sidemenu-card>
                            <document-sidemenu-attachment
                                [file]="file"
                                [removable]="!demandReadOnly"
                                (removeClicked)="demand.deleteFile(file)"
                            ></document-sidemenu-attachment>
                        </document-sidemenu-card>
                    }
                </document-sidemenu-section>
                <document-sidemenu-section>
                    <document-sidemenu-section-header
                        [sectionTitle]="'Interne Anhänge' | translate"
                        icon="fas fa-eye-slash"
                    ></document-sidemenu-section-header>
                    <document-sidemenu-section-empty-message>
                        {{ 'Keine internen Anhänge vorhanden' | translate }}
                    </document-sidemenu-section-empty-message>
                    @if (!demandReadOnly) {
                        <document-sidemenu-section-action
                            (actionClick)="upload(null, true)"
                        ></document-sidemenu-section-action>
                    }
                    @for (file of demand.internalFiles; track file.id) {
                        <document-sidemenu-card>
                            <document-sidemenu-attachment
                                [file]="file"
                                [removable]="!demandReadOnly"
                                [internal]="file.internal"
                                (removeClicked)="demand.deleteFile(file)"
                            ></document-sidemenu-attachment>
                        </document-sidemenu-card>
                    }
                </document-sidemenu-section>
                <div class="container-fluid">
                    <ng-container *ngTemplateOutlet="demandBody"></ng-container>
                    <ng-content></ng-content>
                </div>
                </document-layout>
            } @else {
                <div class="row">
                    @if (pdfPreviewStore.showPreview() && pdfPreviewStore.isMobile()) {
                        <div class="col-12 mb-2">
                            <div class="pdf-mobile-wrapper">
                                <pdf-preview [files]="pdfPreviewStore.pdfFiles()"></pdf-preview>
                            </div>
                        </div>
                    }
                    <div class="col">
                        <ng-container *ngTemplateOutlet="demandBody"></ng-container>
                    </div>
                    @if (pdfPreviewStore.showPreview() && !pdfPreviewStore.isMobile()) {
                        <div class="col-6 mt-2">
                            <div class="pdf-sticky-wrapper">
                                <pdf-preview [files]="pdfPreviewStore.pdfFiles()"></pdf-preview>
                            </div>
                        </div>
                    }
                </div>
            }
        }
        <!-- Shared demand body; side menu (document-layout) only wraps it in the requisition view. -->
        <ng-template #demandBody>
            @if (!showCompanyCodeInHeader && (companyCodes.length > 1 || (demand.companyCodeId === null))) {
                <div class="row mb-2">
                    <div class="col">
                        <iim-card [header]="companyCodeHeader">
                            <ng-template #companyCodeHeader>
                                <div class="px-2">
                                    <div class="row">
                                        <div class="col">
                                            <h3 class="mb-0">
                                                <em class="fas fa-building-columns pe-2"></em>
                                                {{ 'Buchungskreis' | translate }}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                            <div class="px-3 py-3">
                                @if (companyCodeOptionsLoading) {
                                    <div class="d-flex align-items-center text-description">
                                        <em class="fas fa-spinner fa-spin me-2"></em>
                                        {{ 'Buchungskreise' | translate }}
                                    </div>
                                } @else {
                                    @if (companyCodeLoadFailed) {
                                        <div class="alert alert-warning mb-0">
                                            {{ 'Fehler beim Laden der Buchungskreise' | translate }}
                                        </div>
                                    } @else if (!companyCodes.length) {
                                        <div class="alert alert-info mb-0">
                                            {{ 'Sie haben noch keine Buchungskreise angelegt' | translate }}
                                        </div>
                                    } @else if (showCompanyCodeSelection) {
                                        <label class="form-label">{{ 'Buchungskreis' | translate }}</label>
                                        <select
                                            class="form-select"
                                            [ngModel]="selectedCompanyCodeId"
                                            (ngModelChange)="handleCompanyCodeSelection($event)"
                                            [disabled]="companyCodeUpdating"
                                        >
                                            <option [ngValue]="null" disabled>
                                                {{ 'Bitte wählen Sie einen Buchungskreis aus' | translate }}
                                            </option>
                                            @for (companyCode of companyCodes; track companyCode.id) {
                                                <option [ngValue]="companyCode.id">
                                                    {{ companyCode.code }} - {{ companyCode.name }}
                                                </option>
                                            }
                                        </select>
                                        @if (companyCodeUpdating) {
                                            <div class="d-flex align-items-center text-description mt-2">
                                                <em class="fas fa-spinner fa-spin me-2"></em>
                                                {{ 'Speichern' | translate }}
                                            </div>
                                        }
                                        @if (requiresCompanyCodeSelection) {
                                            <div class="alert alert-danger mt-3 mb-0">
                                                {{ 'Bitte wählen Sie zuerst einen Buchungskreis aus' | translate }}
                                            </div>
                                        }
                                    } @else {
                                        <div>
                                            <div class="text-description mb-1">
                                                {{ 'Buchungskreis' | translate }}
                                            </div>
                                            <div class="fw-bold">
                                                {{ companyCodeLabel(demand.companyCodeId) }}
                                            </div>
                                        </div>
                                    }
                                }
                            </div>
                        </iim-card>
                    </div>
                </div>
            }
            <div class="row">
                @if (demand.isAnnounced && demand.consumer && isPurchaseRequisition) {
                    <div class="col-sm-12 col-md-6 col-lg-6 col-xl mb-2">
                        <iim-card [header]="titleHeader">
                            <ng-template #titleHeader>
                                <div class="px-2">
                                    <div class="row">
                                        <div class="col">
                                            <h3>
                                                <em class="fas fa-clock-rotate-left pe-2"></em>
                                                {{ 'Kopfdaten' | translate }}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                            <div class="px-3">
                                @if (showCompanyCodeInHeader) {
                                    <div class="row">
                                        <div class="col-lg col-md-12">
                                            <strong>{{ 'Buchungskreis' | translate }}:</strong>
                                        </div>
                                        <div class="col">{{ companyCodeHeaderLabel }}</div>
                                    </div>
                                }
                                <div class="row" *showOnDebug>
                                    <div class="col-lg col-md-12">
                                        <strong>ID:</strong>
                                    </div>
                                    <div class="col">
                                        <span copyToClipboard>{{ purchaseRequisition?.id }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg col-md-12">
                                        <strong>{{ 'Nummer' | translate }}:</strong>
                                    </div>
                                    <div class="col">
                                        <span copyToClipboard>{{ purchaseRequisition?.number }}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg col-md-12">
                                        <strong>{{ 'Gemeldet am' | translate }}:</strong>
                                    </div>
                                    <div class="col">{{ purchaseRequisition?.announcedTimestamp }}</div>
                                </div>
                                @if (purchaseRequisition) {
                                    <div class="row">
                                        <div class="col-lg col-md-12">
                                            <strong>{{ 'Status' | translate }}:</strong>
                                        </div>
                                        <div class="col">
                                            <purchase-requisition-status-display
                                                [status]="purchaseRequisition.status.value"
                                            ></purchase-requisition-status-display>
                                        </div>
                                    </div>
                                    @if (purchaseRequisition.orderStatus) {
                                        <div class="row">
                                            <div class="col-lg col-md-12">
                                                <strong>{{ 'Bestellstatus' | translate }}:</strong>
                                            </div>
                                            <div class="col">
                                                <purchase-requisition-order-status-display
                                                    [status]="purchaseRequisition.orderStatus"
                                                ></purchase-requisition-order-status-display>
                                            </div>
                                        </div>
                                    }
                                    @if (purchaseRequisition.deliveryStatus) {
                                        <div class="row">
                                            <div class="col-lg col-md-12">
                                                <strong>{{ 'Lieferstatus' | translate }}:</strong>
                                            </div>
                                            <div class="col">
                                                <purchase-requisition-delivery-status-display
                                                    [status]="purchaseRequisition.deliveryStatus"
                                                ></purchase-requisition-delivery-status-display>
                                            </div>
                                        </div>
                                    }
                                }
                                @if (demand.consumer) {
                                    <div class="row">
                                        <div class="col-lg col-md-12">
                                            <strong>{{ 'Bedarfsträger' | translate }}:</strong>
                                        </div>
                                        <div class="col">{{ demand.consumer | person }}</div>
                                    </div>
                                }
                                @if (isPending) {
                                    <div class="row mt-1">
                                        <div class="col-auto">
                                            <div class="alert alert-info d-flex mb-2">
                                                <div class="col">
                                                    <div class="row">
                                                        <div class="col">
                                                            {{
                                                                'Diese Bedarfsmeldung befindet sich im Freigabeprozess'
                                                                    | translate
                                                            }}
                                                        </div>
                                                    </div>
                                                    <div class="row my-1">
                                                        <div class="col-auto">
                                                            <purchase-requisition-process-display-button
                                                                [purchaseRequisitionId]="purchaseRequisition.id"
                                                                [purchaseRequisitionNumber]="purchaseRequisition.number"
                                                            >
                                                                <em class="fas fa-eye"></em>
                                                                {{ 'Prozess Status anzeigen' | translate }}
                                                            </purchase-requisition-process-display-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div class="row mt-1">
                                    <div class="col">
                                        <approval-overview
                                            [purchaseRequisitionId]="purchaseRequisition.id"
                                        ></approval-overview>
                                    </div>
                                </div>
                            </div>
                        </iim-card>
                    </div>
                }
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl mb-2">
                    <demand-supplier-display
                        [demandId]="demand.id"
                        [readonly]="demandReadOnly"
                        [companyCodeId]="demand.companyCodeId"
                        [currency]="demandCurrency"
                        [suppliers]="demand.suppliers"
                        [supplierChangeAllowed]="supplierChangeAllowed"
                        [required]="supplierRequired"
                        [isValid]="suppliersValid()"
                        [currencyConflictMessage]="supplierCurrencyConflictMessage"
                        [currencyCheckErrorMessage]="supplierCurrencyCheckErrorMessage"
                        [currencyCheckPending]="supplierCurrencyCheckPending"
                        (currencyCheckRetry)="retrySupplierCurrencyCompatibility()"
                        (supplierSelected)="addSupplier($event)"
                        (supplierRemoved)="removeSupplier($event.companyId.value)"
                        (supplierChanged)="supplierChanged()"
                        (supplierContactChanged)="changeSupplierContact($event)"
                    ></demand-supplier-display>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl mb-2">
                    <demand-shipping-display
                        [readonly]="demandReadOnly"
                        [companyAddress]="demand?.shippingAddress?.companyAddressWithContact"
                        [availableShippingAddresses]="shippingCandidates"
                        (addressChanged)="demand.updateShippingAddress($event)"
                    ></demand-shipping-display>
                </div>
                @if (history) {
                    <div class="col-sm-12 col-md-6 col-lg-6 col-xl mb-2">
                        <demand-actitvity [demand]="demand" [history]="history"></demand-actitvity>
                    </div>
                }
            </div>
            @if (!demandReadOnly) {
                <div class="row mb-2">
                    <div class="col">
                        <iim-card [header]="demandTitleHeader">
                            <ng-template #demandTitleHeader>
                                <div class="px-2">
                                    <div class="row">
                                        <div class="col">
                                            <h3>
                                                <em class="fas fa-tag pe-2"></em>
                                                {{ 'Titel des Bedarfs' | translate }}
                                                @if (demand.title) {
                                                    <span class="text-description font-07">
                                                        ({{ demand.title.length }} / {{ MAX_TITLE_LENGTH }}
                                                        {{ 'Zeichen' | translate }})
                                                    </span>
                                                } @else {
                                                    <span class="text-description font-07">
                                                        - {{ 'optional' | translate }}
                                                    </span>
                                                }
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                            <div class="row align-items-center mx-auto">
                                <div class="col ps-4">
                                    <input
                                        class="form-control"
                                        [(ngModel)]="demand.title"
                                        data-cy="PURCHASE_REQUISITION_TITLE_INPUT"
                                        maxlength="{{ MAX_TITLE_LENGTH }}"
                                        [placeholder]="'Titel des Bedarfs' | translate"
                                    />
                                </div>
                            </div>
                        </iim-card>
                    </div>
                </div>
            }
            @if (demand) {
                <div class="row mb-2">
                    <div class="col">
                        <iim-card [header]="articleHeader" [footer]="productFooter">
                            <ng-template #articleHeader>
                                <div class="px-3">
                                    <div class="row align-items-center mb-2">
                                        <div class="col">
                                            <h3 class="mb-0">
                                                <em class="fas fa-box pe-2"></em>
                                                {{ 'Artikeldaten' | translate }}
                                            </h3>
                                        </div>
                                        @if (!demandReadOnly) {
                                            <div class="col-auto">
                                                <button
                                                    type="button"
                                                    class="btn btn-outline-dark btn-sm"
                                                    (click)="openUpdateDeliveryDateDialog()"
                                                    [disabled]="!canBulkEditDeliveryDate"
                                                >
                                                    <em class="fas fa-calendar-day pe-1"></em>
                                                    {{ 'Liefertermin für alle ändern' | translate }}
                                                </button>
                                            </div>
                                            <div class="col-auto">
                                                <accounting-change
                                                    [disabled]="demand.products.length === 0 || !accountingsEditable"
                                                    [editCostCenter]="true"
                                                    [editProject]="true"
                                                    [editCustomAccounting]="true"
                                                    [editGeneralLedgerAccount]="true"
                                                    [companyCodeId]="selectedCompanyCodeId ?? demand.companyCodeId ?? ''"
                                                    [hideClassification]="true"
                                                    [showPurchasingGroup]="canSelectPurchasingGroup"
                                                    [showPurchasingGroupPreview]="!canEditPurchasingGroup && purchasingGroupAvailable"
                                                    [showMaterialGroup]="true"
                                                    (accountingsChanged)="updateAllAccountings($event)"
                                                ></accounting-change>
                                            </div>
                                        }
                                    </div>
                                    @if (
                                        articleValidationActionable &&
                                        (validator?.showAccountingError ||
                                            validator.showClassificationError ||
                                            validator.showSiteError ||
                                            (!demand.readOnly && !validator.supplierArticleNumberValid) ||
                                            !validator.articlePriceValidForOrder ||
                                            !validator.deliveryDateValid ||
                                            demand.numOfCurrenciesUsed > 1)
                                    ) {
                                        <div class="row">
                                            <div class="col">
                                                <div class="alert alert-danger my-0">
                                                    @if (validator?.showAccountingError) {
                                                        <div>
                                                            {{
                                                                'Nicht alle verpflichtenden Kontierungen wurden ausgefüllt.'
                                                                    | translate
                                                            }}
                                                        </div>
                                                    }
                                                    @if (validator?.showClassificationError) {
                                                        <div>
                                                            {{
                                                                'Nicht alle Klassifikationen wurden ausgefüllt.'
                                                                    | translate
                                                            }}
                                                        </div>
                                                    }
                                                    @if (validator?.showSiteError) {
                                                        <div>
                                                            {{
                                                                'Nicht alle verpflichtenden Standorte wurden ausgewählt.'
                                                                    | translate
                                                            }}
                                                        </div>
                                                    }
                                                    @if (demand.numOfCurrenciesUsed > 1) {
                                                        <div>
                                                            {{
                                                                'Bitte wählen Sie die selbe Währung für alle Produkte.'
                                                                    | translate
                                                            }}
                                                        </div>
                                                    }
                                                    @if (!demand.readOnly && !validator?.supplierArticleNumberValid) {
                                                        <div>
                                                            {{
                                                                'Die Angabe einer Lieferanten Artikelnummer ist verpflichtend.'
                                                                    | translate
                                                            }}
                                                        </div>
                                                    }
                                                    @if (!validator?.deliveryDateValid) {
                                                        <div>
                                                            {{
                                                                'Die Angabe eines Lieferdatums ist verpflichtend.'
                                                                    | translate
                                                            }}
                                                        </div>
                                                    }
                                                    @if (!validator?.articlePriceValidForOrder) {
                                                        <div>
                                                            {{
                                                                'Um eine Bestellung abzuschließen, geben Sie bitte für alle Artikel in der Bedarfsmeldung einen Preis an.'
                                                                    | translate
                                                            }}
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </ng-template>
                            @if (validator) {
                                <div class="px-3">
                                    @if (articles && articles.length) {
                                        <div class="mb-2">
                                            @for (article of articles; track article.id; let articleIndex = $index) {
                                                <div class="mb-3">
                                                    <document-item
                                                        [imagePreview]="true"
                                                        [enableFileEdit]="!demandReadOnly"
                                                        (uploadClicked)="upload(article.original)"
                                                        (filesDropped)="article.original.addFile($event, false)"
                                                    >
                                                        <document-item-name>{{ article.name }}</document-item-name>
                                                        <document-item-description>
                                                            {{ article.description }}
                                                        </document-item-description>
                                                        @if (!demandReadOnly) {
                                                            <document-item-action
                                                                [actionLabel]="'Löschen' | translate"
                                                                icon="fas fa-trash"
                                                                colorClass="text-danger"
                                                                (triggered)="removeProduct(article)"
                                                            ></document-item-action>
                                                            <document-item-action
                                                                [actionLabel]="'Bearbeitern' | translate"
                                                                icon="fas fa-pen"
                                                                colorClass="text-primary"
                                                                (triggered)="editArticle(article)"
                                                            ></document-item-action>
                                                            <document-item-action
                                                                [actionLabel]="'Duplizieren' | translate"
                                                                icon="fas fa-copy"
                                                                colorClass="text-primary"
                                                                (triggered)="addProduct(article.original.itemId)"
                                                            ></document-item-action>
                                                        }
                                                        <document-item-attribute [spacingAbove]="true">
                                                            <document-item-label>
                                                                {{ 'Artikelnummer' | translate }}
                                                            </document-item-label>
                                                            <document-item-value>
                                                                {{ article.original.data.customerProductNumber }}
                                                            </document-item-value>
                                                        </document-item-attribute>
                                                        @if (article.manufacturer) {
                                                            <document-item-attribute [spacingAbove]="true">
                                                                <document-item-label>
                                                                    {{ 'Hersteller' | translate }}
                                                                </document-item-label>
                                                                <document-item-value>
                                                                    {{ article.manufacturer }}
                                                                </document-item-value>
                                                            </document-item-attribute>
                                                        }
                                                        @if (article.manufacturer) {
                                                            <document-item-attribute>
                                                                <document-item-label>
                                                                    {{ 'Art. Nr. Hersteller' | translate }}
                                                                </document-item-label>
                                                                <document-item-value>
                                                                    {{ article.manufacturerArticleSku }}
                                                                </document-item-value>
                                                            </document-item-attribute>
                                                        }
                                                        @if (article.supplierArticleNumber) {
                                                            <document-item-attribute [spacingAbove]="true">
                                                                <document-item-label>
                                                                    {{ 'Art. Nr. Lieferant' | translate }}
                                                                </document-item-label>
                                                                <document-item-value>
                                                                    {{ article.supplierArticleNumber }}
                                                                </document-item-value>
                                                            </document-item-attribute>
                                                        }
                                                        <document-item-attribute [spacingAbove]="true">
                                                            <document-item-label>
                                                                @if (!article.orderUnit) {
                                                                    <em
                                                                        class="fas fa-exclamation-triangle text-danger"
                                                                        [matTooltip]="
                                                                            'Keine Angaben über die Einheit vorhanden!'
                                                                                | translate
                                                                        "
                                                                    ></em>
                                                                }
                                                                {{ 'Bestelleinheit' | translate }}
                                                            </document-item-label>
                                                            <document-item-value>
                                                                {{ article.orderUnit | unit }}
                                                            </document-item-value>
                                                        </document-item-attribute>
                                                        <document-item-attribute>
                                                            <document-item-label>
                                                                {{ 'Inhalt' | translate }}
                                                            </document-item-label>
                                                            <document-item-value>
                                                                {{ article.numberOfContentUnitsPerOrderUnit }}
                                                                {{
                                                                    article.contentUnit
                                                                        | unit: article.numberOfContentUnitsPerOrderUnit
                                                                }}
                                                            </document-item-value>
                                                        </document-item-attribute>
                                                        @if (article.original.delivery.preferredDeliveryDate) {
                                                            <document-item-attribute [spacingAbove]="true">
                                                                <document-item-label>
                                                                    {{ 'Lieferdatum' | translate }}
                                                                </document-item-label>
                                                                <document-item-value>
                                                                    {{
                                                                        article.original.delivery.preferredDeliveryDate
                                                                            | dayjs: 'L'
                                                                    }}
                                                                </document-item-value>
                                                            </document-item-attribute>
                                                        }
                                                        @if (article.deliveryTime > 0) {
                                                            <document-item-attribute [spacingAbove]="true">
                                                                <document-item-label>
                                                                    {{ 'Lieferzeit' | translate }}
                                                                </document-item-label>
                                                                <document-item-value>
                                                                    {{ article.deliveryTime }}
                                                                    {{
                                                                        article.deliveryTimeUnit
                                                                            | deliveryTime: article.deliveryTime
                                                                    }}
                                                                </document-item-value>
                                                            </document-item-attribute>
                                                        }
                                                        @if (article.original.delivery.partialDeliveryPossible) {
                                                            <document-item-attribute [spacingAbove]="true">
                                                                <document-item-label>
                                                                    <div class="partial-delivery-possible">
                                                                        <em class="fas fa-info-circle pe-1"></em>
                                                                        {{ 'Teillieferung möglich' | translate }}
                                                                    </div>
                                                                </document-item-label>
                                                                <document-item-value></document-item-value>
                                                            </document-item-attribute>
                                                        }
                                                        @if (article.original.comment.comment) {
                                                            <document-item-note>
                                                                <p>{{ article.original.comment.comment }}</p>
                                                            </document-item-note>
                                                        }
                                                        @if (article.original.comment.internalComment) {
                                                            <document-item-note-internal>
                                                                <p>
                                                                    {{ article.original.comment.internalComment }}
                                                                </p>
                                                            </document-item-note-internal>
                                                        }
                                                        @for (file of article.original.files; track file.id) {
                                                            <document-item-attachment
                                                                [fileResponse]="file"
                                                                (removed)="article.original.deleteFile(file)"
                                                            ></document-item-attachment>
                                                        }
                                                        <document-item-accounting>
                                                        <!--
                                                            EPROC-11619: lib-site-selection stays outside the defer/stagger below.
                                                            It is a single cheap, shared settings+sites lookup (coalesced across all
                                                            positions since the cache-interceptor fix), not the N+1/POST-heavy tree
                                                            accounting-selection-v2 is - so there is nothing to gain from delaying it.
                                                            Deferring it used to seed its site-required check as "invalid" until its
                                                            own async settle-and-maybe-autoselect chain finished mounting, which for
                                                            later-batch positions could still be pending when the release/task view
                                                            was read, making "Site valid" flicker false for a demand that was already
                                                            fully valid - this fixes that by never delaying it in the first place.
                                                        -->
                                                        <div class="mt-2">
                                                            <lib-site-selection
                                                                [companyCodeId]="siteSelectionCompanyCodeId"
                                                                [selectedSiteCode]="article.original.siteCode ?? null"
                                                                [editable]="!demandReadOnly"
                                                                (siteChanged)="updateSite($event, article.original.itemId!)"
                                                                (validityChange)="applySiteValidation(article.original.itemId!, $event)"
                                                            ></lib-site-selection>
                                                        </div>
                                                        @defer (on viewport; when articleIndex <= eagerLoadCutoffIndex) {
                                                            @let taskId = task?.id ?? '';
                                                            <accounting-selection-v2
                                                                [taskId]="taskId"
                                                                [costCenterEditable]="accountingsEditable"
                                                                [projectEditable]="accountingsEditable"
                                                                [generalLedgerAccountEditable]="accountingsEditable"
                                                                [customAccountAssignmentEditable]="accountingsEditable"
                                                                [demandId]="demand.id"
                                                                [values]="article.accountingInput"
                                                                [classificationCode]="article.classification?.irdicc ?? null"
                                                                [materialGroupId]="article.original.materialGroupCode || null"
                                                                [companyCodeId]="selectedCompanyCodeId ?? demand.companyCodeId ?? ''"
                                                                (validationChanged)="
                                                                    applyAccountingValidation(
                                                                        article.original.itemId!,
                                                                        $event
                                                                    )
                                                                "
                                                                (accountingChanged)="
                                                                    updateAccounting($event, article.original.itemId!)
                                                                "
                                                                (classificationCandidatesChanged)="
                                                                    updateClassificationCandidates(
                                                                        article.original.itemId!,
                                                                        $event
                                                                    )
                                                                "
                                                                (classificationRecommendationSourceLabelChanged)="
                                                                    updateClassificationRecommendationSourceLabel(
                                                                        article.original.itemId!,
                                                                        $event
                                                                    )
                                                                "
                                                                (classificationRecommendationReasonLabelChanged)="
                                                                    updateClassificationRecommendationReasonLabel(
                                                                        article.original.itemId!,
                                                                        $event
                                                                    )
                                                                "
                                                                (materialGroupCandidateCodesChanged)="
                                                                    updateMaterialGroupCandidates(
                                                                        article.original.itemId!,
                                                                        $event
                                                                    )
                                                                "
                                                                (materialGroupRecommendationSourceLabelChanged)="
                                                                    updateMaterialGroupRecommendationSourceLabel(
                                                                        article.original.itemId!,
                                                                        $event
                                                                    )
                                                                "
                                                                (materialGroupRecommendationReasonLabelChanged)="
                                                                    updateMaterialGroupRecommendationReasonLabel(
                                                                        article.original.itemId!,
                                                                        $event
                                                                    )
                                                                "
                                                                (initialized)="checkInitStatus()"
                                                            ></accounting-selection-v2>
                                                            <div class="mt-2">
                                                                <classification-selection
                                                                    [editable]="!demandReadOnly"
                                                                    [value]="article.classification?.irdicc"
                                                                    [allowedIrdiccs]="
                                                                        recommendedClassificationIrdiccsByItemId[
                                                                            article.original.itemId!
                                                                        ] ?? null
                                                                    "
                                                                    [recommendedClassifications]="
                                                                        recommendedClassificationsByItemId[
                                                                            article.original.itemId!
                                                                        ] ?? null
                                                                    "
                                                                    [recommendedSourceLabel]="
                                                                        recommendedClassificationSourceLabelsByItemId[
                                                                            article.original.itemId!
                                                                        ] ?? null
                                                                    "
                                                                    [recommendedReasonLabel]="
                                                                        recommendedClassificationReasonLabelsByItemId[
                                                                            article.original.itemId!
                                                                        ] ?? null
                                                                    "
                                                                    (classificationSelected)="
                                                                        updateClassification(article, $event)
                                                                    "
                                                                    (validationChange)="
                                                                        applyClassificationValidation(
                                                                            article.original.itemId!,
                                                                            $event
                                                                        )
                                                                    "
                                                                ></classification-selection>
                                                            </div>
                                                            <div class="mt-3">
                                                                <material-group-selection
                                                                    [valueCode]="article.original.materialGroupCode || undefined"
                                                                    [editable]="!demandReadOnly"
                                                                    [disabled]="demandReadOnly"
                                                                    [recommendedMaterialGroupCodes]="
                                                                        recommendedMaterialGroupCodesByItemId[
                                                                            article.original.itemId!
                                                                        ] ?? null
                                                                    "
                                                                    [recommendedSourceLabel]="
                                                                        recommendedMaterialGroupSourceLabelsByItemId[
                                                                            article.original.itemId!
                                                                        ] ?? null
                                                                    "
                                                                    [recommendedReasonLabel]="
                                                                        recommendedMaterialGroupReasonLabelsByItemId[
                                                                            article.original.itemId!
                                                                        ] ?? null
                                                                    "
                                                                    (valueChange)="updateMaterialGroup(article, $event)"
                                                                ></material-group-selection>
                                                            </div>
                                                            @if (
                                                                purchasingGroupDisplayed &&
                                                                (article.original.purchasingGroup ||
                                                                    purchasingGroupAvailable)
                                                            ) {
                                                                <div class="mt-3">
                                                                    <app-accounting-base
                                                                        [label]="purchasingGroupLabel"
                                                                        [placeholder]="purchasingGroupSelectPlaceholder"
                                                                        [isReadonly]="!canSelectPurchasingGroup"
                                                                        [isDisabled]="purchasingGroupDisabled"
                                                                        [allowClear]="canSelectPurchasingGroup"
                                                                        [disabledMessage]="purchasingGroupDisabledMessage"
                                                                        [isLoading]="loadingPurchasingGroups"
                                                                        [defaultToFirstOption]="false"
                                                                        [display]="accountingBaseDisplayType.KEY_AND_NAME"
                                                                        [initialSelectedCode]="purchasingGroupSelectedCodeFor(article)"
                                                                        [accountingOptions]="purchasingGroupOptionsFor(article)"
                                                                        localFullSelection
                                                                        (selectedOptionChange)="handlePurchasingGroupOptionSelected($event, article)"
                                                                        (selectionCleared)="handlePurchasingGroupCleared(article)"
                                                                    ></app-accounting-base>
                                                                </div>
                                                            }
                                                        } @placeholder {
                                                            <div class="d-flex align-items-center text-description py-3">
                                                                <em class="fas fa-spinner fa-spin me-2"></em>
                                                                {{ 'Kontierung wird geladen' | translate }}
                                                            </div>
                                                        }
                                                        </document-item-accounting>
                                                        <document-item-price>
                                                            <document-item-label>
                                                                <span
                                                                    [ngClass]="{
                                                                        'text-danger fw-bold':
                                                                            !validator.articlePriceValidForOrder &&
                                                                            article.price.unitPrice === 0,
                                                                    }"
                                                                >
                                                                    {{ 'Einzelpreis' | translate }}
                                                                </span>
                                                            </document-item-label>
                                                            <document-item-value>
                                                                <display-currency
                                                                    [value]="article.price.unitPrice"
                                                                    [currencyCode]="article.price.currency"
                                                                />
                                                            </document-item-value>
                                                        </document-item-price>
                                                        <document-item-price>
                                                            <document-item-label>
                                                                {{ 'Steuersatz' | translate }}
                                                            </document-item-label>
                                                            <document-item-value>
                                                                {{ article.price.taxPercent }}%
                                                            </document-item-value>
                                                        </document-item-price>
                                                        <document-item-price>
                                                            <document-item-label>
                                                                {{ 'Bestellmenge' | translate }}
                                                            </document-item-label>
                                                            <document-item-value>
                                                                @if (!demandReadOnly) {
                                                                    <iim-decimal-input-v2
                                                                        [(value)]="article.quantity"
                                                                        (valueChange)="priceUpdater$.next(article)"
                                                                        [minimumValue]="0.01"
                                                                        [showPlusMinusBtn]="true"
                                                                    ></iim-decimal-input-v2>
                                                                } @else {
                                                                    {{
                                                                        article.quantity.toLocaleString(
                                                                            getUserLanguage()
                                                                        )
                                                                    }}
                                                                    {{ article.orderUnit | unit: article.quantity }}
                                                                }
                                                            </document-item-value>
                                                        </document-item-price>
                                                        <document-item-price>
                                                            <document-item-label>
                                                                <strong class="font-12">
                                                                    {{ 'Gesamt' | translate }}
                                                                </strong>
                                                            </document-item-label>
                                                            <document-item-value>
                                                                <strong>
                                                                    <display-currency
                                                                        [value]="article.price.linePrice"
                                                                        [currencyCode]="article.price.currency"
                                                                    />
                                                                </strong>
                                                            </document-item-value>
                                                        </document-item-price>
                                                    </document-item>
                                                </div>
                                            }
                                        </div>
                                    } @else {
                                        <div class="mb-2">
                                            <div class="alert alert-danger">
                                                @if (!demandReadOnly) {
                                                    <span>
                                                        {{ 'Es wurden noch keine Artikel hinzugefügt' | translate }}
                                                    </span>
                                                }
                                                @if (demandReadOnly) {
                                                    <span>
                                                        @if (!demand.isAnnounced) {
                                                            <span>
                                                                {{ 'Der Bedarf ist leer...' | translate }}
                                                            </span>
                                                        }
                                                        @if (demand.isAnnounced) {
                                                            <span>
                                                                {{ 'Die Bedarfsmeldung ist leer...' | translate }}
                                                            </span>
                                                        }
                                                    </span>
                                                }
                                            </div>
                                        </div>
                                    }
                                    @if (!demandReadOnly) {
                                        <div class="row mb-2 justify-content-center">
                                            <button
                                                class="btn btn-primary px-3 py-1"
                                                data-cy="ADD_ARTICLE"
                                                (click)="addProduct()"
                                            >
                                                <em class="fas fa-plus fa-1_5x mt-1"></em>
                                            </button>
                                        </div>
                                    }
                                    @if (demand?.additionalCosts?.length > 0) {
                                        <div class="mb-2 mt-3">
                                            <div class="mb-3">
                                                <h5>{{ 'Zusätzliche Kosten' | translate }}:</h5>
                                            </div>

                                            @for (additionalCost of demand.additionalCosts; track additionalCost.id) {
                                                <div class="mb-3">
                                                    <demand-additional-costs
                                                        [isReadonly]="demandReadOnly || !accountingsEditable"
                                                        [demandId]="demand.id"
                                                        [additionalCost]="additionalCost"
                                                        [taskId]="task ? task.id : ''"
                                                        [companyCodeId]="selectedCompanyCodeId ?? demand.companyCodeId ?? null"
                                                        (validationChanged)="
                                                            applyAccountingValidation(additionalCost.id, $event)
                                                        "
                                                        (initialized)="checkInitStatus()"
                                                        (destroyed)="validator.removeItemValidation(additionalCost.id)"
                                                    ></demand-additional-costs>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                            <ng-template #productFooter>
                                <div class="px-3">
                                    @if (demand.price && demand.price.length) {
                                        @for (price of demand.price; track price) {
                                            <demand-price [price]="price"></demand-price>
                                        }
                                    }
                                </div>
                            </ng-template>
                        </iim-card>
                    </div>
                </div>
            }
            @if (!purchaseRequisition && (!demandReadOnly || demand.files.length)) {
                <div class="row">
                    <div
                        class="col-lg-6 col-md-12 mb-2"
                        appDropzone
                        [multiple]="true"
                        (fileDropped)="demand.addFile($event.formData, false)"
                    >
                        <iim-card [header]="filesHeader">
                            <ng-template #filesHeader>
                                <div class="px-2">
                                    <div class="row">
                                        <div class="col">
                                            <h5>
                                                <em class="fas fa-paperclip pe-2"></em>
                                                {{ 'Anhang' | translate }}
                                            </h5>
                                        </div>
                                        @if (!demandReadOnly) {
                                            <div class="col-auto px-0">
                                                <button
                                                    class="btn btn-outline-dark"
                                                    (click)="upload(null, false)"
                                                    [title]="'Datei anhängen' | translate"
                                                >
                                                    <em class="fas fa-plus"></em>
                                                </button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </ng-template>
                            <div class="px-3">
                                @if (demand.publicFiles.length) {
                                    <div class="row mb-2">
                                        @for (file of demand.publicFiles; track file) {
                                            <div class="col-auto">
                                                <file-download
                                                    [imagePreview]="true"
                                                    [file]="file"
                                                    [removable]="!demandReadOnly"
                                                    (removeClicked)="demand.deleteFile(file)"
                                                ></file-download>
                                            </div>
                                        }
                                    </div>
                                }
                                @if (!demand.publicFiles.length) {
                                    <div class="row mb-2">
                                        <div class="col">
                                            <div class="alert alert-info mb-0">
                                                {{ 'Es wurden noch keine Dateien angehängt' | translate }}
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </iim-card>
                    </div>
                    <div
                        class="col-lg-6 col-md-12 mb-2"
                        appDropzone
                        [multiple]="true"
                        (fileDropped)="demand.addFile($event.formData, true)"
                    >
                        <iim-card [header]="filesHeaderInternal">
                            <ng-template #filesHeaderInternal>
                                <div class="px-2">
                                    <div class="row">
                                        <div class="col">
                                            <h5>
                                                <em class="fas fa-paperclip pe-2"></em>
                                                {{ 'Interner Anhang' | translate }}
                                            </h5>
                                        </div>
                                        @if (!demandReadOnly) {
                                            <div class="col-auto px-0">
                                                <button
                                                    class="btn btn-outline-dark"
                                                    (click)="upload(null, true)"
                                                    [title]="'Datei anhängen' | translate"
                                                >
                                                    <em class="fas fa-plus"></em>
                                                </button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </ng-template>
                            <div class="px-3">
                                @if (demand.internalFiles.length) {
                                    <div class="row mb-2">
                                        @for (file of demand.internalFiles; track file) {
                                            <div class="col-auto">
                                                <file-download
                                                    [imagePreview]="true"
                                                    [file]="file"
                                                    [removable]="!demandReadOnly"
                                                    [internal]="file.internal"
                                                    (removeClicked)="demand.deleteFile(file)"
                                                ></file-download>
                                            </div>
                                        }
                                    </div>
                                }
                                @if (!demand.internalFiles.length) {
                                    <div class="row mb-2">
                                        <div class="col">
                                            <div class="alert alert-info mb-0">
                                                {{ 'Es wurden noch keine Dateien angehängt' | translate }}
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </iim-card>
                    </div>
                </div>
            }
            @if ((demand.validUntil && demand.validUntil.isValid()) || !demandReadOnly) {
                <div class="row mb-2">
                    <div class="col">
                        <iim-card [header]="validUntilHeader">
                            <ng-template #validUntilHeader>
                                <div class="px-3">
                                    <div class="row">
                                        <div class="col">
                                            <h3 class="m-0">
                                                <em class="fas fa-stopwatch pe-2"></em>
                                                {{ 'Gültig bis' | translate }}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                            <div class="px-3">
                                <div class="mb-3">
                                    @if (!demandReadOnly) {
                                        <div class="row">
                                            <div class="col-12 col-md-6 col-lg-3">
                                                <iim-datepicker
                                                    [minDate]="tomorrow"
                                                    [date]="demand.validUntil"
                                                    [placeholder]="'Gültig bis' | translate"
                                                    [isRequired]="true"
                                                    (dateChange)="updateValidUntil($event)"
                                                ></iim-datepicker>
                                            </div>
                                        </div>
                                    } @else {
                                        {{ demand.validUntil | dayjs }}
                                    }
                                </div>
                                @if (demand.validUntil && !demand.validUntilDateValid && showValidUntilExpiredError) {
                                    <div class="row">
                                        <div class="col-12 col-md-6 col-lg-3">
                                            <div class="mb-2">
                                                <div class="alert mb-0 alert-danger">
                                                    {{ 'Gültigkeitsdatum ist überschritten!' | translate }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                @if (!demand.isAnnounced || isPending) {
                                    @if (!demand.validUntil) {
                                        <div class="row">
                                            <div class="col-12 col-md-6 col-lg-3">
                                                <div class="mb-2">
                                                    <div class="alert mb-0 alert-danger">
                                                        {{ 'Bitte geben Sie eine Gültigkeit ein!' | translate }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    @if (
                                        demand.validUntil &&
                                        demand.validUntilDateAboutToBeInvalid &&
                                        demand.validUntilDateValid
                                    ) {
                                        <div class="row">
                                            <div class="col-12 col-md-6 col-lg-3">
                                                <div class="mb-2">
                                                    <div class="alert mb-0 alert-warning">
                                                        @if (demand.demandValidUntilIsInvalidInDays > 1) {
                                                            <span>
                                                                {{
                                                                    'Nur noch \{\{days\}\} Tage gültig!'
                                                                        | translate
                                                                            : {
                                                                                  days: demand.demandValidUntilIsInvalidInDays,
                                                                              }
                                                                }}
                                                            </span>
                                                        }
                                                        @if (demand.demandValidUntilIsInvalidInDays === 1) {
                                                            <span>
                                                                {{
                                                                    'Nur noch \{\{days\}\} Tag gültig!'
                                                                        | translate
                                                                            : {
                                                                                  days: demand.demandValidUntilIsInvalidInDays,
                                                                              }
                                                                }}
                                                            </span>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                }
                            </div>
                        </iim-card>
                    </div>
                </div>
            }
            @if (demand.conditions || !demandReadOnly) {
                <div class="row mb-2">
                    <div class="col">
                        <iim-card [header]="conditionsHeader">
                            <ng-template #conditionsHeader>
                                <div class="px-2">
                                    <div class="row">
                                        <div class="col">
                                            <h3>
                                                <em class="fas fa-file-contract pe-2"></em>
                                                {{ 'Konditionen' | translate }}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                            <div class="px-3">
                                @if (!demandReadOnly) {
                                    <div class="row mb-1">
                                        <div class="col d-flex flex-column">
                                            <label #conditionsLabel for="demand-conditions">
                                                {{ 'Konditionen' | translate }}
                                            </label>
                                            <textarea
                                                id="demand-conditions"
                                                class="form-control"
                                                rows="8"
                                                [formControl]="conditionsCtrl"
                                                [label]="conditionsLabel"
                                                errorHighlight
                                                mark-required
                                                [isRequired]="false"
                                                [placeholder]="'Alle Angebotskonditionen' | translate"
                                            ></textarea>
                                        </div>
                                    </div>
                                } @else {
                                    <p class="newlines mb-0">{{ demand.conditions }}</p>
                                }
                            </div>
                        </iim-card>
                    </div>
                </div>
            }
            @if (demand.messageToSupplier || demand.internalMessage || !demandReadOnly) {
                <div class="row mb-2">
                    <div class="col">
                        <iim-card [header]="commentsHeader">
                            <ng-template #commentsHeader>
                                <div class="px-2">
                                    <div class="row">
                                        <div class="col">
                                            <h3>
                                                <em class="fas fa-note-sticky pe-2"></em>
                                                {{ 'Nachrichten' | translate }}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                            <div class="px-3">
                                @if (demand.messageToSupplier || !demandReadOnly) {
                                    <div class="row mb-2">
                                        <div class="col-12">
                                            @if (!demandReadOnly) {
                                                <text-module-selection
                                                    [category]="TextModuleCategoryEnum.PURCHASE_REQUISITION"
                                                    [formControl]="messageToSupplierCtrl"
                                                    [title]="'Nachricht an den Lieferanten' | translate"
                                                ></text-module-selection>
                                            }
                                            @if (demandReadOnly) {
                                                <p class="newlines">
                                                    {{ demand.messageToSupplier }}
                                                </p>
                                            }
                                        </div>
                                    </div>
                                }
                                @if (demand.internalMessage || !demandReadOnly) {
                                    <div class="row mb-2">
                                        <div class="col">
                                            @if (!demandReadOnly) {
                                                <text-module-selection
                                                    [category]="TextModuleCategoryEnum.APPROVAL"
                                                    [formControl]="internalMessageCtrl"
                                                    [title]="'Kommentar an den Freigeber' | translate"
                                                ></text-module-selection>
                                            }
                                            @if (demandReadOnly) {
                                                <p class="newlines">
                                                    {{ demand.internalMessage }}
                                                </p>
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        </iim-card>
                    </div>
                </div>
            }
            @if (purchaseRequisition?.resultsInOrder) {
                <div class="row mb-2">
                    <div class="col">
                        <demand-transmission-info [demand]="demand"></demand-transmission-info>
                    </div>
                </div>
            }
            @if (demand.validationError; as validationError) {
                <div class="row mb-2 justify-content-end">
                    <div class="col-auto">
                        <div class="alert alert-danger mb-0">
                            <div class="mb-2">
                                <strong>
                                    <em class="fas fa-times-circle pe-1"></em>
                                    {{ 'Es sind Validierungsfehler aufgetreten' | translate }}
                                </strong>
                            </div>
                            @if (validationError.otherErrorsMessage) {
                                @for (message of otherErrorsMessages(validationError.otherErrorsMessage); track message) {
                                    <div>{{ message }}</div>
                                }
                            }
                        </div>
                    </div>
                </div>
            }
            <div class="row justify-content-end mb-2">
                <div class="col" *showOnDebug>
                    <h5>Demand Validation State</h5>
                    Accounting: {{ validator?.accountingValid }}
                    <br />
                    Supplier Article number: {{ validator?.supplierArticleNumberValid }}
                    <br />
                    Delivery Date: {{ validator?.deliveryDateValid }}
                    <br />
                    Supplier Article number required:
                    {{ validator?.options.supplierArticleNumberRequired }}
                    <br />
                    Demand metadata: {{ demand.valid }}
                    <br />
                    Classification: {{ validator?.classificationValid }}
                    <br />
                    Demand valid until: {{ validator?.validUntilValid.value }}
                    <br />
                    Demand valid until required: {{ validator?.options.validUntilRequired }}
                    <br />
                    Supplier valid: {{ validator?.suppliersValid.value }}
                    <br />
                    Supplier required: {{ validator?.options.suppliersRequired }}
                    <br />
                    Currency valid: {{ validator?.currencyValid.value }}
                    <br />
                    Supplier currency valid: {{ validator?.supplierCurrencyValid.value }}
                    <br />
                    Site valid: {{ validator?.siteValid }}
                    <br />
                    Purchasing group valid: {{ validator?.purchasingGroupValid }}
                    <br />
                    Company code present: {{ !!demand.companyCodeId }}
                    <br />
                    <strong>All</strong>
                    : {{ validator?.validForNextStep() }}
                </div>

                @if (!this.demand.readOnly && currencyConflict) {
                    <div class="col-12 mb-2">
                        <!-- Warning, not an error: the demand stays editable; only the conversion into an order is blocked (EPROC-11425). -->
                        <div class="alert alert-warning mb-0">
                            <!-- demandCurrency is null once the positions use more than one currency;
                                 naming none is better than an empty gap in the sentence. -->
                            @if (noSelectableCurrencies) {
                                <!-- Empty customer-supplier intersection: deliberate dead end
                                     (EPROC-11425, decision 06.08.2026) — name the way out instead
                                     of dangling an empty "selectable" list. -->
                                {{
                                    'Der Mandant und die gewählten Lieferanten haben keine gemeinsame Währung — eine Bestellung ist so nicht möglich. Wählen Sie andere Lieferanten oder lassen Sie die Währungs-Stammdaten erweitern.'
                                        | translate
                                }}
                            } @else if (demandCurrency && customerRejectsDemandCurrency) {
                                <!-- Name the actual party: this rejection is the customer's own master
                                     data, it exists even without any supplier (EPROC-11425 reopen #2). -->
                                {{
                                    'Die Währung \{\{currency\}\} ist vom Mandanten nicht zugelassen. Wählbar sind: \{\{selectable\}\}'
                                        | translate
                                            : {
                                                  currency: demandCurrency,
                                                  selectable: selectableCurrencyList,
                                              }
                                }}
                            } @else if (demandCurrency) {
                                {{
                                    'Die Währung \{\{currency\}\} wird nicht von allen gewählten Lieferanten akzeptiert. Wählbar sind: \{\{selectable\}\}'
                                        | translate
                                            : {
                                                  currency: demandCurrency,
                                                  selectable: selectableCurrencyList,
                                              }
                                }}
                            } @else {
                                {{
                                    'Die Währungen des Belegs werden nicht von allen gewählten Lieferanten akzeptiert. Wählbar sind: \{\{selectable\}\}'
                                        | translate: { selectable: selectableCurrencyList }
                                }}
                            }
                        </div>
                    </div>
                }
                @if (!this.demand.readOnly && validator && !validator.purchasingGroupValid) {
                    <div class="col-12 mb-2">
                        <div class="alert alert-warning mb-0">
                            {{
                                'Bitte wählen Sie eine Warengruppe mit gültiger Einkaufsgruppen-Zuordnung, bevor Sie fortfahren.'
                                    | translate
                            }}
                        </div>
                    </div>
                }
                @if (demand.hasIncotermDeviation && !demand.isAnnounced) {
                    <div class="col-12 mb-2">
                        <div class="alert alert-warning mb-0" role="alert">
                            <em class="fas fa-exclamation-triangle pe-2"></em>
                            {{
                                'Der gewählte Incoterm weicht vom Standard-Incoterm eines Lieferanten ab. Sie können den Bedarf dennoch melden.'
                                    | translate
                            }}
                        </div>
                    </div>
                }
                @if (emailValidationErrors.length > 0 && !this.demand.isAnnounced) {
                    <div class="col-12 mb-2">
                        <div class="alert alert-danger mb-0">
                            <div class="mb-0">
                                @for (error of emailValidationErrors; track error) {
                                    <div>{{ error }}</div>
                                }
                            </div>
                        </div>
                    </div>
                }
                <div
                    class="col-12 col-md-auto mb-2 mb-md-0"
                    *acl="{ resource: AclResource.demandToRfq, action: AclAction.SHOW }"
                >
                    @if (!demandReadOnly && !demand.isAnnounced) {
                        <button
                            class="btn btn-primary w-100"
                            (click)="createRfq()"
                            [disabled]="
                                !validator?.validForRfq ||
                                isCompleted ||
                                emailValidationErrors.length > 0 ||
                                isCheckingEmail
                            "
                            data-cy="ANNOUNCE_DEMAND"
                        >
                            <em class="fas fa-bullhorn px-1"></em>
                            {{ 'Anfrage an Lieferanten senden' | translate }}
                        </button>
                    }
                </div>
                <div class="col-12 col-md-auto mb-2 mb-md-0">
                    @if (!demandReadOnly && !demand.isAnnounced) {
                        <button
                            class="btn btn-success w-100"
                            (click)="announceDemand()"
                            [disabled]="
                                !validator?.validForNextStep() ||
                                isCompleted ||
                                loading ||
                                emailValidationErrors.length > 0
                            "
                            data-cy="ANNOUNCE_DEMAND"
                        >
                            <em class="fas fa-bullhorn px-1"></em>
                            {{ 'Bedarf melden' | translate }}
                        </button>
                    }
                </div>
            </div>
        </ng-template>
    </base-site-layout>
</div>
